// ADD COMMAS
function addCommas(nStr){
	nStr += '';
	x = nStr.split('.');
	x1 = x[0];
	x2 = x.length > 1 ? '.' + x[1] : '';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + '.' + '$2');
	}
	return x1 + x2;
}

// QUANTITY
function quantityTrigger(button, value) {
	var type = button.data('type'),
		val = parseFloat(value.val());
		
	if (type === "plus")
		(val < 10000 && val >= 1) ? val += 1 : val = 10000;
	else if(type === "minus")
		(val > 1) ? val -= 1 : val = 1;
	value.val(val);
}
function quantityVal(value) {
	var val = value.val(),
		newVal = parseFloat(val);
						
	if(val=='' || val=='0' || isNaN(val)) {
		value.val(1);
	}
	if(newVal > 10000){
		value.val(10000);
	}
}

function smoothScroll(elem, header) {
	let targetData = "";

	if ($(elem).prop('data-target'))
		targetData = $(elem).data("target");
	else
		targetData = $(elem).attr("href");

	var // target = $(targetData),
		targetPos = $(targetData).offset().top,
		headerH = '',
		scrollTop = '';

	if(header != 0 || header != '')
		headerH = $(header).height();
	else
		headerH = 0

	scrollTop = targetPos - headerH;

	$('body, html').stop().animate({scrollTop: scrollTop}, 800);
}

parallaxBackground = (target, speed = 0.75, posX = "50% ") => {
	let _pos = $(window).scrollTop(),
		_targetPos = $(target).offset().top,
		_result = (0 - ((_pos - _targetPos) * speed)) + 'px';
	
	$(target).css('background-position', posX + _result);
}

section = () => {
	let scrollTop = $(window).scrollTop(),
		section = $("section"),
		winH = $(window).height();

	section.each(function() {
		let _targetPos = $(this).offset().top,
			_pos = _targetPos - (winH * 3/4);
		if (!$(this).hasClass('actived') && scrollTop >= _pos) {
			$(this).addClass('actived');
		}
	});
}

countUp = (elem) => {
	let _data = $(elem).data('value'),
		_number = parseInt(_data);

	$({countNum: 0}).animate({
		countNum: _number
	}, 
	{
		duration: 5000,
		easing: 'linear',
		step: function () {
			elem.text(Math.floor(this.countNum));
		},
		complete: function () {
			elem.text(this.countNum);
		}
	});
}

setVersion = () => {
	let _time = Date.now(),
		_css = $('#main-css').length ? $('#main-css') : null,
		_js = $('#main-js').length ? $('#main-js') : null;
	
	if (_css != null) {
		let _src = _css.attr('href'),
			_ver = [_src, '?v=', _time].join('');
		_css.attr('href', _ver);
		console.log(_ver);
	}
	
	if (_js != null) {
		let _src = _js.attr('src'),
			_ver = [_src, '?v=', _time].join('');
		_js.attr('src', _ver);
		console.log(_ver);
	}
}
